import Button from '@/components/Button';
import Modal from '@/components/Modal';

interface Props {
  open: boolean;
  title: string;
  message: string;
  confirmLabel: string;
  cancelLabel: string;
  /** Red confirm button, for actions that cannot be undone. */
  destructive?: boolean;
  loading?: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

/** Confirmation that says the consequence first (same anatomy as the events P14 modals). */
const ConfirmModal = ({
  open,
  title,
  message,
  confirmLabel,
  cancelLabel,
  destructive = false,
  loading = false,
  onConfirm,
  onClose,
}: Props) => (
  <Modal
    open={open}
    title={title}
    onDismiss={onClose}
    closeDisabled={loading}
    actions={
      <>
        <Button variant="text" onClick={onClose} disabled={loading}>
          {cancelLabel}
        </Button>
        <Button
          variant="contained"
          color={destructive ? 'error' : 'primary'}
          loading={loading}
          onClick={onConfirm}
        >
          {confirmLabel}
        </Button>
      </>
    }
  >
    {message}
  </Modal>
);

export default ConfirmModal;
